import './BulkAddLimitPopover.scss';

import React from 'react';

import { Popover, PopoverProps } from 'antd';

export type BulkAddLimitPopoverProps = PopoverProps & {
	isDisabled?: boolean;
};

export const BulkAddLimitPopover: React.FC<BulkAddLimitPopoverProps> = ({ children, isDisabled, ...rest }) =>
	<Popover
		classNames={ { root: 'bulk-add-popover disabled-popover' } }
		placement='bottom'
		title='Too Many Selected'
		trigger={ isDisabled ? [] : 'hover' }
		{ ...rest }>
		<span>{ children }</span>
	</Popover>;
